import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { Avatar } from "@mui/material";
import classes from "./ThemeUserInfo.module.css";
import { useContext } from "react";
import AuthContext from "../../../store/adminStore/admin-auth-context";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import { NavLink, useNavigate } from "react-router-dom";
import useHttpFetch from "../../../hooks/useHttpFetch";
import { toast } from "react-toastify";
import clearERPStores from "../../../utils/cache/clearERPStores";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

const ThemeUserInfo = () => {
  const { clientAuthInfo, setClientAuthInfo } = useContext(AuthContext);
  const { isLoading: actionIsHappening, sendRequest: actionFetch } = useHttpFetch();
  const navigate = useNavigate();

  const logoutHandler = async (e) => {
    e.preventDefault();
    const result = await actionFetch({ url: "Logout", noMiddleUrl: true });
    if (result.resIsOk && result.response?.message === "successfully logged out") {
      clearERPStores();
      setClientAuthInfo((ps) => ({
        ...ps,
        isLoggedIn: false,
        mobileNumber: null,
        userId: null,
        baseUserId: null,
        userTypeEnum: null,
        organizationalTitles: null,
        username: null,
        firstName: null,
        latName: null,
        username: null,
      }));
      toast.success("شما با موفقیت خارج شدید");
      navigate("/admin/login");
    }
  };

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <>
          <div className={classes.startItem}>
            <div className={classes.userImgContainer}>
              {/* <Avatar
                alt="Remy Sharp"
                sx={{ width: "24px", height: "24px" }}
                src={<AccountCircleOutlinedIcon />}
              /> */}
              <AccountCircleOutlinedIcon />
            </div>
            <div className={classes.userInfoContainer}>
              <p className={classes.userName}>
                {`${clientAuthInfo?.firstName}  ${clientAuthInfo?.lastName}` || clientAuthInfo?.username}
              </p>
              {/* <p className={classes.userPosition}>عنوان شغلی</p> */}
            </div>
          </div>
          <span className={classes.logoutContainer} onClick={logoutHandler}>
            {/* <MultiLanTxt tid="LOG_OUT" /> */}
            <LogoutRoundedIcon className={classes.moreIcon} />
          </span>
        </>
      ) : (
        <NavLink to="/login" className={classes.loginLink}>
          <div className={classes.loginContainer}>
            <span>ورود</span>

            <LoginRoundedIcon />

            <span>ثبت نام</span>
          </div>
        </NavLink>
      )}
    </>
  );
};

export default ThemeUserInfo;
